var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.env !== 'production')?_c('div',{staticClass:"p-1 text-center text-uppercase label-indicator",class:_vm.getEnv.class},[_vm._v(" "+_vm._s(_vm.getEnv.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }